import React from "react";
import { Nav } from "../sections/Nav/Nav";
import { Navbar2 } from "../sections/Nav2/Navbar2";
import Footer from "../sections/Footer/Footer";
import { NewsResultPage } from "./NewsResultPage"; // импортируем страницу с результатами
import "./NewsPages.css";
import FooterNews from "../sections/FooterNews/FooterNews";

export const NewsPages = () => {
    return (
        <div className="desktop">
            <Navbar2 />
            <Nav />

            {/* Баннер */}
            <div className="news-banner">
                <img
                    src="https://www.gazeta.uz/media/img/2021/09/fgLk7N16323135499251_l.jpg"
                    alt="Баннер новостей"
                    className="news-banner-img"
                />

            </div>

            {/* Страница результатов новостей */}
            <NewsResultPage />

            <FooterNews />
        </div>
    );
};
